
import Dialog from './component';

export default Dialog

